import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

import { IconDirective } from '../icon/icon.directive';

@Component({
  selector: 'tt-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
  imports: [MatCardModule, TranslocoModule, MatIconModule, IconDirective],
  host: {
    'data-testid': 'tt-page-not-found',
  },
})
export class PageNotFoundComponent {}
